/**
 * Política de complejidad alineada al User Pool (mismo criterio que registro).
 * @param {string} value
 * @returns {string|null} mensaje de error o null si es válida
 */
export const validatePassword = (value) => {
  if (value.length < 8) return 'La contraseña debe tener al menos 8 caracteres';
  if (!/[A-Z]/.test(value)) return 'La contraseña debe contener al menos una letra mayúscula';
  if (!/[a-z]/.test(value)) return 'La contraseña debe contener al menos una letra minúscula';
  if (!/[0-9]/.test(value)) return 'La contraseña debe contener al menos un número';
  if (!/[^A-Za-z0-9]/.test(value)) return 'La contraseña debe contener al menos un carácter especial';
  return null;
};
